import React, { useEffect, useState } from "react";
import { fetchCollectionAction } from "state/actions/collectionActions";
import { MY_RESERVATION } from "state/constants/actions";
import { useDispatch, useSelector } from "react-redux";
import { requestPastFutureReservation } from "apis/myreservation";
import AccountPastFutureReservation from "../components/AccountPastFutureReservation";
import { useAuth0 } from "@auth0/auth0-react";
import { getUserReservations } from "../apis/middlewareEndpoints";

const PastFutureReservation = ({ ...props }) => {
  const [defaultPerPage, setDefaultPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState("1");
  const [currentType, setCurrentType] = useState("upcoming");
  const { collection: my_reservation, uiState, error } = useSelector(
    (state) => state.my_reservation
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (process.env.GATSBY_ENABLE_AUTH0 !== "true") {
      fetchCollectionAction(
        MY_RESERVATION,
        dispatch,
        requestPastFutureReservation,
        {
          page: currentPage,
          per_page: defaultPerPage,
          filter_type: currentType,
        }
      );
    }
  }, [currentPage, currentType]);
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  useEffect(() => {
    if (process.env.GATSBY_ENABLE_AUTH0 === "true") {
      if (isAuthenticated) {
        const getMemberReservation = async () => {
          const token = await getAccessTokenSilently();

          fetchCollectionAction(MY_RESERVATION, dispatch, getUserReservations, {
            page: currentPage,
            per_page: defaultPerPage,
            filter_type: currentType,
            token,
          });
        };

        getMemberReservation();
      }
    }
  }, [isAuthenticated, getAccessTokenSilently, currentPage, currentType]);

  return (
    <AccountPastFutureReservation
      data={my_reservation}
      langData={props.langData}
      currentPage={currentPage}
      defaultPerPage={defaultPerPage}
      setCurrentPage={setCurrentPage}
      currentType={currentType}
      setCurrentType={setCurrentType}
      setDefaultPerPage={setDefaultPerPage}
      openWidgetAction={props.openWidgetAction}
    />
  );
};

export default PastFutureReservation;
